export const types = {
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
};
